module.exports = __webpack_public_path__ + "static/media/logowom.359ae3be.svg";